var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79435 5.6756L7.18099 1.45574C7.95666 0.848086 9.04282 0.848086 9.81849 1.45574L15.2051 5.6756C15.82 6.15731 15.9908 6.87427 15.9994 7.70295C15.9999 7.74787 15.9984 7.79129 15.995 7.83608C15.9602 8.2957 15.7192 11.1041 14.8288 14.257C14.5142 15.1346 13.7738 16 12.7553 16H4.2442C3.22566 16 2.48532 15.1346 2.17066 14.257C1.28026 11.1041 1.03932 8.29569 1.00447 7.83608C1.00108 7.79129 0.99962 7.74787 1.00008 7.70295C1.00864 6.87427 1.17945 6.15731 1.79435 5.6756Z",
    stroke: "#22282B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.25C9.88071 12.25 11 11.1307 11 9.75C11 8.36929 9.88071 7.25 8.5 7.25C7.11929 7.25 6 8.36929 6 9.75C6 11.1307 7.11929 12.25 8.5 12.25Z",
    stroke: "#22282B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomer);
export default __webpack_public_path__ + "static/media/homer.2e085fc2c8e9f1d34f5de828a5c5da03.svg";
export { ForwardRef as ReactComponent };